<template>
  <div class="airEfficiencyWrap" v-loading="loading">
    <!-- <el-button v-if="showDetailType" class="detailBtn" type="primary" size="medium"
            @click="showDetailType = false">返回</el-button>
        <el-button v-else class="detailBtn" type="primary" size="medium" @click="showDetailType = true">查询详细信息</el-button> -->
    <el-tabs
      v-if="dataTabs.length"
      v-model="dataTabsValue"
      type="card"
      @tab-click="changeTab"
    >
      <el-tab-pane
        :key="item?.id || item.name"
        v-for="item in dataTabs"
        :label="item.title"
        :name="item.name"
        lazy
      >
        <Panel
          v-if="dataTabsValue===item.name"
          :key="item?.id || item.name"
          :assetId="item?.id || item.name"
          :showDetailType="showDetailType"
          :titleLeft="titleLeft"
          :titleRight="titleRight"
          :energyType="item?.energyType"
        />
      </el-tab-pane>
    </el-tabs>
    <el-empty
      v-else
      class="empty"
      :image-size="500"
      description="暂无数据"
    ></el-empty>
  </div>
</template>
<script>
import Panel from "@/components/zixitong/airSystem/efficiency/Panel";
import api from "@/api";
import { getProjectVal, matchingParamsName } from "@/assets/js/utils";
export default {
  components: { Panel },
  data() {
    return {
      showDetailType: false,
      dataTabsValue: null,
      dataTabsId: null,
      dataTabsEnergyType: "cool",
      dataTabs: [],
      titleLeft: [],
      titleRight: [],
      loading: false,
    };
  },
  methods: {
    //获取中央空调列表
    async getCentralAirConditioning() {
      let res = await api.ACRGetCentralAirConditioning({
        projectId: getProjectVal("Id"),
        deviceType: "中央空调主机,锅炉,空气源热泵",
      });
      if (res && res.data.code == 200) {
        this.dataTabs = res.data.data.map((item, index) => {
          item.title = item.name;
          if (index === 0) {
            this.dataTabsValue = item.name;
            this.dataTabsId = item.id;
            this.dataTabsEnergyType = item.energyType;
            this.getTitleData(item.id, item.energyType);
          }
          return item;
        });
      } else {
        console.log("获取中央空调列表失败");
      }
    },
    getTitleData(assetId, energyType) {
      this.loading = true;
      const q1 = this.getTitleLeftData(assetId, energyType);

      const queryType = energyType || this.dataTabsEnergyType;
      if (queryType === "cool") {
        const q2 = this.getTitleRightData(assetId);
        Promise.all([q1, q2])
          .then((res) => {
            let res1 = res[0];
            if (res1 && res1.data.code == 200) {
              this.titleLeft = this.dealTitleData(res1.data.data, true);
            } else {
              console.log("获取设备状态统计失败");
            }
            let res2 = res[1];
            if (res2 && res2.data.code == 200) {
              this.titleRight = this.dealTitleData(res2.data.data);
            } else {
              console.log("获取获取IPLV和额定SEER失败");
            }
          })
          .catch((err) => {
            console.log("---getTitleData---err----", err);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        Promise.all([q1])
          .then((res) => {
            let res1 = res[0];
            if (res1 && res1.data.code == 200) {
              this.titleLeft = this.dealTitleData(res1.data.data, true);
            } else {
              console.log("获取设备状态统计失败");
            }
          })
          .catch((err) => {
            console.log("---getTitleData---err----", err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    dealTitleData(data = [], dealSort = false) {
      const newData = [];
      let lastObj = {}; //分集水管在最后
      Array.isArray(data) &&
        data.forEach((element) => {
          const { name, value, chart = {} } = element;
          const { on = 0, off = 0 } = chart;
          const obj = {
            name: matchingParamsName(name),
            value,
            details: this._.isEmpty(chart)
              ? null
              : [
                  {
                    name: "开启",
                    value: on,
                    colorValue: "#28CCCB",
                  },
                  {
                    name: "关闭",
                    value: off,
                  },
                ],
          };
          if (matchingParamsName(name) === "分集水管") {
            lastObj = obj;
          } else {
            newData.push(obj);
          }
        });
      dealSort && newData.push(lastObj);
      return newData;
    },
    //获取设备状态统计
    async getTitleLeftData(assetId = null, dataTabsEnergyType) {
      return await api.ACRGetEquipmentStatusStatistics({
        projectId: getProjectVal("Id"),
        assetId: assetId || this.dataTabsId,
        energyType: dataTabsEnergyType || this.dataTabsEnergyType,
      });
    },
    //获取获取IPLV和额定SEER
    async getTitleRightData(assetId = null) {
      return await api.ACRGetIPLVAndSEER({
        projectId: getProjectVal("Id"),
        assetId: assetId || this.dataTabsId,
        deviceType: "中央空调主机",
      });
    },
    changeTab(tab) {
      const newId = this.dataTabs[tab.index].id;
      const newEnergyType = this.dataTabs[tab.index].energyType;
      this.dataTabsId = newId;
      this.dataTabsEnergyType = newEnergyType;
      this.getTitleData(newId, newEnergyType);
    },
  },
  created() {
    this.getCentralAirConditioning();
  },
};
</script>
<style lang="scss" scoped>
.airEfficiencyWrap {
  width: calc(100% - 32px);
  margin: 16px;
  background-color: #fff;

  // height: calc(100% - 40px);
  .detailBtn {
    float: right;
    position: relative;
    top: 5px;
  }
}

::v-deep .el-tabs {
  background-color: #f7f7f7;

  .el-tabs__header {
    margin-bottom: 0;
    width: calc(100% - 150px);
    border-bottom-width: 0px;

    .el-tabs__item {
      border-bottom: 0.005208rem solid #e4e7ed !important;
      background-color: #fff;
    }
  }

  .el-tabs__content {
    padding-top: 12px;
  }
}
</style>
